import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Search from '../../../component/common/Search';
import ClientsTable from '../../../component/client/ClientsTable';
import Pagination from '../../../component/common/Pagination';
import SpinnerLoading from '../../../component/common/SpinnerLoading';

export default class ClientsListContainer extends Component {
  static propTypes = {
    clients: PropTypes.array,
    clientsCount: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    companyId: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    setSearch: PropTypes.func.isRequired,
    onSwitchPage: PropTypes.func.isRequired,
    history: PropTypes.shape({
      location: PropTypes.object.isRequired,
      push: PropTypes.func.isRequired,
    }),
  };

  render() {
    const { clients, clientsCount, limit, companyId, projectId, history } = this.props;
    return !clients ? (
      <SpinnerLoading centered={true} />
    ) : (
      <div className="clients-table-container">
        <label className="page-header">Clients</label>
        <Search search={this.props.search} setSearch={this.props.setSearch} />
        <ClientsTable
          clients={clients}
          companyId={companyId}
          projectId={projectId}
          history={history}
        />
        {clientsCount > limit && (
          <Pagination
            pages={this.props.pages}
            page={this.props.page}
            onSwitchPage={this.props.onSwitchPage}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container/client/ClientsListContainer/index.js